(() => {
  if (window.apolaCookieSettingsInitialized) return;
  window.apolaCookieSettingsInitialized = true;

  // Shopify injects its privacy banner script asynchronously.
  // Wait for its documented API; opening preferences never sets consent itself.
  function getPrivacyBanner() {
    return new Promise((resolve, reject) => {
      const started = Date.now();
      const check = () => {
        if (typeof window.privacyBanner?.showPreferences === 'function') {
          resolve(window.privacyBanner);
        } else if (Date.now() - started >= 8000) {
          reject(new Error('Privacy preferences are unavailable'));
        } else {
          window.setTimeout(check, 100);
        }
      };
      check();
    });
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-apola-cookie-settings]');
    if (!button || button.disabled) return;
    const status = button.closest('.apola-cookie-settings').querySelector('[data-apola-cookie-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = true;
    status.textContent = '';
    try {
      const banner = await getPrivacyBanner();
      await banner.showPreferences();
    } catch (error) {
      status.textContent = 'Nie udało się otworzyć ustawień cookies. Odśwież stronę i spróbuj ponownie.';
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
